import { isAxiosError } from 'axios';

const parseJsonBlob = async (blob: Blob): Promise<unknown | undefined> => {
  const text = await blob.text();

  if (!text) {
    return undefined;
  }

  try {
    return JSON.parse(text) as unknown;
  } catch {
    return undefined;
  }
};

export const throwParsedAxiosBlobError = async (error: unknown): Promise<never> => {
  if (!isAxiosError(error)) {
    throw error;
  }

  const data = error.response?.data;

  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    const parsed = await parseJsonBlob(data);

    if (parsed !== undefined && error.response) {
      error.response.data = parsed;
    }
  }

  throw error;
};
